const bindGps = () => import('@/pages/bindGps/index')
const bindGpsMap = () => import('@/pages/bindGps/mapDetail')
const gpsDetail = () => import('@/pages/bindGps/gpsDetail')
const createGps = () => import('@/pages/bindGps/createGps')
export default [{
  path: '/bindGps',
  name: '/bindGps',
  component: bindGps,
  meta: {
    storeKey: 'trs.bindGps.index'
  }
},
{
  path: '/bindGpsMap',
  name: '/bindGpsMap',
  component: bindGpsMap,
  meta: {}
},
{
  path: '/createGps',
  name: '/createGps',
  component: createGps,
  meta: {}
},
{
  path: '/gpsDetail',
  name: '/gpsDetail',
  component: gpsDetail,
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/bindGps/index.js